
import buyerAddPrice from './buyerAddPrice.vue'
import buyerConfirmOrderInfo from './buyerConfirmOrderInfo.vue'
import buyerRefundAccount from './buyerRefundAccount.vue'
import sellerConfirm from './sellerConfirm.vue'

export default {
    name: 'ChangePrice',
    components: {
        buyerAddPrice,
        buyerConfirmOrderInfo,
        buyerRefundAccount,
        sellerConfirm
    },
    props: {
        message: {
            type: Object,
            required: true
        }
    },
    computed: {
        content () {
            return this.message?.content?.content || {}
            // return {
            //     SELLER_CONFIRM: {
            //         title: '改价后订单信息', // 标题
            //         type: 'SELLER_CONFIRM', // 卡片类型
            //         orderId: '1940319062072520706', // 订单id
            //         orderNo: '8705563052351062016', // 订单编号
            //         modifyOrderNo: '8710287101565239296', // 变更记录单号
            //         idToken: '32位UUID', // 按钮防重标识
            //         oldTransactionPrice: '500', // 修改前应付号价
            //         newTransactionPrice: '600', // 修改后应付号价
            //         oldIncomePrice: '450', // 修改前到手
            //         newIncomePrice: '550' // 修改后到手
            //     },
            //     BUYER_CONFIRM: {
            //         title: '请确认订单信息', // 标题
            //         text: '请买家老板确认修改后的订单以及优惠券信息', // 内容
            //         type: 'BUYER_CONFIRM', // 卡片类型
            //         orderId: '1940319062072520706', // 订单id
            //         orderNo: '8705563052351062016', // 订单编号
            //         modifyOrderNo: '8710287101565239296', // 变更记录单号
            //         newTransactionPrice: '600', // 号价
            //         newCompensationFee: '450', // 包赔
            //         newCompensationName: '划算包赔', // 修改后包赔服务名称
            //         newCouponDiscount: '50', // 修改后优惠券减免金额(原订单优惠券可用的情况下会自动挂上，否则为0)
            //         oldCompensationFee: '50', // 修改前包赔应付金额
            //         oldTransactionPrice: '550', // 修改前应付号价
            //         oldCouponDiscount: '50', // 修改前优惠券减免金额
            //         gameId: 21, // 游戏id
            //         baseCompensationFee: 50, // 修改后基础包赔费
            //         addCompensationFee: 200 // 修改后增值包赔费
            //     },
            //     BUYER_PAYMENT_ONLINE: {
            //         title: '请买家支付差价', // 标题
            //         type: 'BUYER_PAYMENT_ONLINE', // 卡片类型
            //         orderId: '1940319062072520706', // 订单id
            //         orderNo: '8705563052351062016', // 订单编号
            //         modifyOrderNo: '8710287101565239296', // 变更记录单号
            //         newTransactionPrice: '600', // 号价
            //         newCompensationFee: '450', // 包赔
            //         newCompensationName: '划算包赔', // 修改后包赔服务名称
            //         couponDiscount: '50', // 优惠券减免金额
            //         differencePrice: '100', // 差价费用
            //         paymentAccount: 'jerry_h@qq.com', // BUYER_PAYMENT_OFFLINE情况下才有
            //         payWay: 'ALIPAY'
            //     },
            //     BUYER_PAYMENT_OFFLINE: {
            //         title: '请买家支付差价', // 标题
            //         type: 'BUYER_PAYMENT_OFFLINE', // 卡片类型
            //         orderId: '1940319062072520706', // 订单id
            //         orderNo: '8705563052351062016', // 订单编号
            //         modifyOrderNo: '8710287101565239296', // 变更记录单号
            //         newTransactionPrice: '600', // 号价
            //         newCompensationFee: '450', // 包赔
            //         newCompensationName: '划算包赔', // 修改后包赔服务名称
            //         couponDiscount: '50', // 优惠券减免金额
            //         differencePrice: '100', // 差价费用
            //         paymentAccount: 'jerry_h@qq.com', // BUYER_PAYMENT_OFFLINE情况下才有
            //         payWay: 'ALIPAY'
            //     },
            //     REFUND_OFFLINE: {
            //         title: '请提供退款账户', // 标题
            //         text: '本次交易需要退差价110元，由于买家为线下付款，请买家提供付款时使用的账户', // 内容
            //         type: 'REFUND_OFFLINE', // 卡片类型
            //         orderId: '1940319062072520706', // 订单id
            //         orderNo: '8705563052351062016', // 订单编号
            //         modifyOrderNo: '8710287101565239296' // 变更记录单号
            //     }
            // }[this.message.type]
        },
        mentionedUser () {
            return this.message?.content?.mentionedInfo?.mentionedContent || ''
        },
        ComponentMap () {
            return {
                // 卖家确认卡片
                SELLER_CONFIRM: sellerConfirm,
                // 买家确认卡片
                BUYER_CONFIRM: buyerConfirmOrderInfo,
                // 买家支付卡片
                BUYER_PAYMENT_ONLINE: buyerAddPrice,
                BUYER_PAYMENT_OFFLINE: buyerAddPrice,
                // 线下退款卡片
                REFUND_OFFLINE: buyerRefundAccount
            }
        }
    }
}
